import { useActiveCard } from '@/forms/composables/useActiveCard';
import { useFluent } from 'fluent-vue';
import { computed, toValue } from 'vue';
import { useRoute } from 'vue-router';

export type TabData = {
    route: string;
    label: string;
};

export function useTabNavigation(tabs: TabData[]) {
    const fluent = useFluent();
    const route = useRoute();
    const { activeCard, getDisabledExplanation } = useActiveCard();

    const tabNavigationItems = computed(() => {
        return tabs.map((tab) => ({
            target: { name: tab.route },
            routeName: tab.route,
            label: tab.label,
            disabledExplanation: getDisabledExplanation(tab.route),
        }));
    });

    const tabsDisabledText = computed(() => fluent.$t('tabs-disabled', { name: toValue(activeCard).label }));

    const activeTabHeadline = computed(() => {
        return fluent.$t('tab-panel', {
            activeTabName: tabNavigationItems.value.find((item) => item.routeName === route.name)?.label ?? '',
        });
    });

    return {
        tabNavigationItems,
        tabsDisabledText,
        activeTabHeadline,
    };
}
